<template>
  <div class="home">
    <project-dom></project-dom>
    <!-- <partner-dom></partner-dom> -->
    <div class="sep"></div>
    <notice-dom></notice-dom>
    <contact-dom></contact-dom>
  </div>
</template>
<script>
import Vue from 'vue';
import ProjectDom from '@/components/project/project';
import NoticeDom from '@/components/notice/notice';
import PartnerDom from '@/components/partner/partner';
import ContactDom from '@/components/contact/contact';
export default {
  name: 'Index',
  data() {
     return {

     }
  },
  created() {
  },
  methods: {
  },
  components: {
    NoticeDom,
    PartnerDom,
    ProjectDom,
    ContactDom
  }
}
</script>
<style scoped lang="stylus" rel="stylesheet/stylus">
  .sep
    width 100%
    height 20px
    background #e8e8e8
</style>




// WEBPACK FOOTER //
// src/components/index.vue